export const getSubdomain = () => {
  if (import.meta.env.DEV) {
    return 'localhost';
  }

  return window.location.hostname.split('.')[0];
};
